import clsx from 'clsx';
import {useRef, useState} from 'react';
import styles from './Controls.module.scss';

export interface SelectProps<T> {
  title?: string;
  options: {value: T; text: string}[];
  className?: string;
  main?: boolean;
  disabled?: boolean;
  value: T;
  onChange: (value: T) => void;
}

export function Select<T>({
  options,
  value,
  onChange,
  title,
  main,
  disabled,
  className,
}: SelectProps<T>) {
  const [open, setOpen] = useState(false);
  const [rect, setRect] = useState<DOMRect | null>(null);
  const triggerRef = useRef<HTMLDivElement>();

  const selectedIndex = options.findIndex(o => o.value === value);

  const handleTriggerClick = () => {
    if (disabled) return;
    if (open) {
      setOpen(false);
    } else {
      setRect(triggerRef.current.getBoundingClientRect());
      setOpen(true);
    }
  };

  return (
    <>
      <div
        ref={triggerRef}
        title={title}
        className={clsx(
          styles.select,
          className,
          main && styles.main,
          disabled && styles.disabled,
        )}
        onClick={handleTriggerClick}
      >
        <span className={styles.selectText}>
          {selectedIndex >= 0 ? options[selectedIndex].text : ''}
        </span>
      </div>
      {open && rect && (
        <>
          <div
            className={styles.selectBackdrop}
            onClick={() => setOpen(false)}
          />
          <div
            className={clsx(styles.selectDropdown, main && styles.main)}
            style={{
              left: rect.left,
              top: rect.bottom + 4,
              minWidth: Math.max(rect.width, 120),
            }}
          >
            {options.map((option, index) => (
              <div
                key={index}
                className={clsx(
                  styles.selectOption,
                  index === selectedIndex && styles.selectOptionActive,
                )}
                onClick={() => {
                  onChange(option.value);
                  setOpen(false);
                }}
              >
                {option.text}
              </div>
            ))}
          </div>
        </>
      )}
    </>
  );
}
